import { ApostatudoApiFetchGiratudoStatusAdapter } from './api-fetch-giratudo/apostatudo-api-fetch-giratudo-status.adapter';
import { ApostatudoApiPostGiratudoParticipateAdapter } from './api-fetch-giratudo/apostatudo-api-post-giratudo-participate.adapter';
import { ApostatudoApiFetchGiratudoLeaderboardAdapter } from './api-fetch-giratudo/apostatudo-api-fetch-giratudo-leaderboard.adapter';
import { ApostatudoApiFetchGiratudoHistoryAdapter } from './api-fetch-giratudo/apostatudo-api-fetch-giratudo-history.adapter';
import { ApostatudoApiFetchGiratudoPrizesAdapter } from './api-fetch-giratudo/apostatudo-api-fetch-giratudo-prizes.adapter';
import { ApostatudoApiFetchStoriesAdapter } from './api-fetch-stories/apostatudo-api-fetch-stories.adapter';
import { ApostatudoApiRegisterUserJourneyEventAdapter } from './api-register-user-journey-event/apostatudo-api-register-user-journey-event.adapter';
import { FingerprintJsDeviceFingerprintAdapter } from './device-fingerprint/fingerprintjs-device-fingerprint.adapter';
import { ApostatudoApiFetchLastGamesAdapter } from './api-fetch-last-games/apostatudo-api-fetch-last-games.adapter';
import { ApostatudoApiUpdateLastGamesAdapter } from './api-update-last-games/apostatudo-api-update-last-games.adapter';
import { ApostatudoApiFetchBannersAdapter } from './api-fetch-banners/apostatudo-api-fetch-banners.adapter';
import { ApostatudoApiFetchHomeSectionsAdapter } from './api-fetch-home-sections/apostatudo-api-fetch-home-sections.adapter';
import { ApostatudoApiFetchPerfilOficialSectionsAdapter } from './api-fetch-perfil-oficial-sections/apostatudo-api-fetch-perfil-oficial-sections.adapter';
import { ApostatudoApiFetchGameFiltersAdapter } from './api-fetch-game-filters/apostatudo-api-fetch-game-filters.adapter';
import { ApostatudoApiFetchGameFilterOptionsAdapter } from './api-fetch-game-filter-options/apostatudo-api-fetch-game-filter-options.adapter';
import { ApostatudoApiFetchPerfilOficialBannersAdapter } from './api-fetch-perfil-oficial-banners/apostatudo-api-fetch-perfil-oficial-banners.adapter';
import { ApostatudoApiFetchHomeMenuAdapter } from './api-fetch-home-menu/apostatudo-api-fetch-home-menu.adapter';
import { ApostatudoApiFetchCuratedEventsAdapter } from './api-fetch-curated-events/apostatudo-api-fetch-curated-events.adapter';
import { ApostatudoApiFetchFaqAdapter } from './api-fetch-faq/apostatudo-api-fetch-faq.adapter';
import { ApostatudoApiFetchBlogPostsAdapter } from './api-fetch-blog/apostatudo-api-fetch-blog-posts.adapter';
import { ApostatudoApiFetchBlogPostAdapter } from './api-fetch-blog/apostatudo-api-fetch-blog-post.adapter';
import { ApostatudoApiRedeemPromocodeAdapter } from './api-redeem-promocode/apostatudo-api-redeem-promocode.adapter';
import { ApostatudoApiSmarticoProfileEventAdapter } from './api-smartico-profile-event/apostatudo-api-smartico-profile-event.adapter';
import { ApostatudoApiFetchRoulettesAdapter } from './api-roulette/apostatudo-api-fetch-roulettes.adapter';
import { ApostatudoApiFetchRouletteDetailAdapter } from './api-roulette/apostatudo-api-fetch-roulette-detail.adapter';
import { ApostatudoApiPostRouletteSpinAdapter } from './api-roulette/apostatudo-api-post-roulette-spin.adapter';
import { ApostatudoApiFetchRoulettePrizeHistoryAdapter } from './api-roulette/apostatudo-api-fetch-roulette-prize-history.adapter';
import type { ApiFetchGiratudoStatusPort } from '~/handlers/ports/api-fetch-giratudo-status.port';
import type { ApiPostGiratudoParticipatePort } from '~/handlers/ports/api-post-giratudo-participate.port';
import type { ApiFetchGiratudoLeaderboardPort } from '~/handlers/ports/api-fetch-giratudo-leaderboard.port';
import type { ApiFetchGiratudoHistoryPort } from '~/handlers/ports/api-fetch-giratudo-history.port';
import type { ApiFetchGiratudoPrizesPort } from '~/handlers/ports/api-fetch-giratudo-prizes.port';
import type { ApiRegisterUserJourneyEventPort } from '~/handlers/ports/api-register-user-journey-event.port';
import type { DeviceFingerprintPort } from '~/handlers/ports/device-fingerprint.port';
import type { ApiFetchStoriesPort } from '~/handlers/ports/api-fetch-stories.port';
import type { ApiFetchLastGamesPort } from '~/handlers/ports/api-fetch-last-games.port';
import type { ApiUpdateLastGamesPort } from '~/handlers/ports/api-update-last-games.port';
import type { ApiFetchBannersPort } from '~/handlers/ports/api-fetch-banners.port';
import type { ApiFetchHomeSectionsPort } from '~/handlers/ports/api-fetch-home-sections.port';
import type { ApiFetchPerfilOficialSectionsPort } from '~/handlers/ports/api-fetch-perfil-oficial-sections.port';
import type { ApiFetchGameFiltersPort } from '~/handlers/ports/api-fetch-game-filters.port';
import type { ApiFetchGameFilterOptionsPort } from '~/handlers/ports/api-fetch-game-filter-options.port';
import type { ApiFetchPerfilOficialBannersPort } from '~/handlers/ports/api-fetch-perfil-oficial-banners.port';
import type { ApiFetchHomeMenuPort } from '~/handlers/ports/api-fetch-home-menu.port';
import type { ApiFetchCuratedEventsPort } from '~/handlers/ports/api-fetch-curated-events.port';
import type { ApiFetchFaqPort } from '~/handlers/ports/api-fetch-faq.port';
import type { ApiFetchBlogPostsPort } from '~/handlers/ports/api-fetch-blog-posts.port';
import type { ApiFetchBlogPostPort } from '~/handlers/ports/api-fetch-blog-post.port';
import type { ApiRedeemPromocodePort } from '~/handlers/ports/api-redeem-promocode.port';
import type { ApiSmarticoProfileEventPort } from '~/handlers/ports/api-smartico-profile-event.port';
import type { ApiFetchRoulettesPort } from '~/handlers/ports/api-fetch-roulettes.port';
import type { ApiFetchRouletteDetailPort } from '~/handlers/ports/api-fetch-roulette-detail.port';
import type { ApiPostRouletteSpinPort } from '~/handlers/ports/api-post-roulette-spin.port';
import type { ApiFetchRoulettePrizeHistoryPort } from '~/handlers/ports/api-fetch-roulette-prize-history.port';

export const adapterRegistry: Record<string, unknown> = {
  apiFetchGiratudoStatus: new ApostatudoApiFetchGiratudoStatusAdapter(),
  apiPostGiratudoParticipate: new ApostatudoApiPostGiratudoParticipateAdapter(),
  apiFetchGiratudoLeaderboard:
    new ApostatudoApiFetchGiratudoLeaderboardAdapter(),
  apiFetchGiratudoHistory: new ApostatudoApiFetchGiratudoHistoryAdapter(),
  apiFetchGiratudoPrizes: new ApostatudoApiFetchGiratudoPrizesAdapter(),
  apiFetchStories: new ApostatudoApiFetchStoriesAdapter(),
  apiRegisterUserJourneyEvent:
    new ApostatudoApiRegisterUserJourneyEventAdapter(),
  deviceFingerprint: new FingerprintJsDeviceFingerprintAdapter(),
  apiFetchLastGames: new ApostatudoApiFetchLastGamesAdapter(),
  apiUpdateLastGames: new ApostatudoApiUpdateLastGamesAdapter(),
  apiFetchBanners: new ApostatudoApiFetchBannersAdapter(),
  apiFetchHomeSections: new ApostatudoApiFetchHomeSectionsAdapter(),
  apiFetchPerfilOficialSections:
    new ApostatudoApiFetchPerfilOficialSectionsAdapter(),
  apiFetchGameFilters: new ApostatudoApiFetchGameFiltersAdapter(),
  apiFetchGameFilterOptions: new ApostatudoApiFetchGameFilterOptionsAdapter(),
  apiFetchPerfilOficialBanners:
    new ApostatudoApiFetchPerfilOficialBannersAdapter(),
  apiFetchHomeMenu: new ApostatudoApiFetchHomeMenuAdapter(),
  apiFetchCuratedEvents: new ApostatudoApiFetchCuratedEventsAdapter(),
  apiFetchFaq: new ApostatudoApiFetchFaqAdapter(),
  apiFetchBlogPosts: new ApostatudoApiFetchBlogPostsAdapter(),
  apiFetchBlogPost: new ApostatudoApiFetchBlogPostAdapter(),
  apiRedeemPromocode: new ApostatudoApiRedeemPromocodeAdapter(),
  apiSmarticoProfileEvent: new ApostatudoApiSmarticoProfileEventAdapter(),
  apiFetchRoulettes: new ApostatudoApiFetchRoulettesAdapter(),
  apiFetchRouletteDetail: new ApostatudoApiFetchRouletteDetailAdapter(),
  apiPostRouletteSpin: new ApostatudoApiPostRouletteSpinAdapter(),
  apiFetchRoulettePrizeHistory:
    new ApostatudoApiFetchRoulettePrizeHistoryAdapter(),
};

export type AdapterMap = {
  apiFetchGiratudoStatus: ApiFetchGiratudoStatusPort;
  apiPostGiratudoParticipate: ApiPostGiratudoParticipatePort;
  apiFetchGiratudoLeaderboard: ApiFetchGiratudoLeaderboardPort;
  apiFetchGiratudoHistory: ApiFetchGiratudoHistoryPort;
  apiFetchGiratudoPrizes: ApiFetchGiratudoPrizesPort;
  apiFetchStories: ApiFetchStoriesPort;
  apiRegisterUserJourneyEvent: ApiRegisterUserJourneyEventPort;
  deviceFingerprint: DeviceFingerprintPort;
  apiFetchLastGames: ApiFetchLastGamesPort;
  apiUpdateLastGames: ApiUpdateLastGamesPort;
  apiFetchBanners: ApiFetchBannersPort;
  apiFetchHomeSections: ApiFetchHomeSectionsPort;
  apiFetchPerfilOficialSections: ApiFetchPerfilOficialSectionsPort;
  apiFetchGameFilters: ApiFetchGameFiltersPort;
  apiFetchGameFilterOptions: ApiFetchGameFilterOptionsPort;
  apiFetchPerfilOficialBanners: ApiFetchPerfilOficialBannersPort;
  apiFetchHomeMenu: ApiFetchHomeMenuPort;
  apiFetchCuratedEvents: ApiFetchCuratedEventsPort;
  apiFetchFaq: ApiFetchFaqPort;
  apiFetchBlogPosts: ApiFetchBlogPostsPort;
  apiFetchBlogPost: ApiFetchBlogPostPort;
  apiRedeemPromocode: ApiRedeemPromocodePort;
  apiSmarticoProfileEvent: ApiSmarticoProfileEventPort;
  apiFetchRoulettes: ApiFetchRoulettesPort;
  apiFetchRouletteDetail: ApiFetchRouletteDetailPort;
  apiPostRouletteSpin: ApiPostRouletteSpinPort;
  apiFetchRoulettePrizeHistory: ApiFetchRoulettePrizeHistoryPort;
};

export function resolveAdapter<K extends keyof AdapterMap>(
  key: K,
): AdapterMap[K] {
  return adapterRegistry[key] as AdapterMap[K];
}
